export default __webpack_public_path__ + "static/media/recs-mapa.2324dad7.png";